// Ключ для доступа к issue внутри дочерних компонентов FillStep и FillStepPortal
import { InjectionKey } from 'vue';

import { IssueApi } from 'SharedDir/backend/api';

export const IsIssueKey = Symbol('issue');

/**
 * Ключ для проброса функции по открытию меню экспорта файла по
 * шаблонам заявления из полей.
 */
export const IssueExportingMenuKey = Symbol('ExportingMenu') as InjectionKey<
  () => ReturnType<typeof IssueApi.exportFilledIssueTemplate>
>;
